import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { Waypoint } from 'react-waypoint';
import { LoadingSpinnerPage } from '../../components/atomic/Loaders/LoadingSpinner';
import Placeholder from '../molecule/Placeholder';

const Container = styled.div`
  padding: 10px;
`
const PlaceholderStyled = styled(Placeholder)`
  margin: 100px auto;
`
const GridStyled = styled(Grid)`
  
`

const LoadingSpinnerWaypoint = styled(LoadingSpinnerPage)`
  margin-top: 20px;
  opacity: 0.5;
`

const CardGrid = ({
  data,
  small,
  renderItem,
  nextPage,
  isLoading,
  xs,
  sm,
  md,
  lg,
  xl,
  ancestor,
  nothingFound,
}) => {

  if(small) {
    xs = 6; sm = 3; md = 2; lg = 2; xl = 1;
  }

  const renderWaypoint = () => {
    return isLoading ? (
      <LoadingSpinnerWaypoint size={30} color='inherit'/>
    ) : (
      <Waypoint
        scrollableAncestor={ancestor}
        onEnter={() => {
          if (data && data.length > 0 && !isLoading && nextPage) {
            nextPage()
          }
        }}
      />
    )
  }


  const getItems = () => {
    if (isLoading && data.length === 0) {
      return (
        <LoadingSpinnerPage/>
      )
    } else if (data && Array.isArray(data) && data.length > 0) {
      return (
        <React.Fragment>
          <GridStyled container spacing={16}>
            {data.map((item, index) => (
              <GridStyled key={`card-grid-${index}`} item xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                {renderItem(item, index)}    
              </GridStyled>
            ))}
          </GridStyled>
          {renderWaypoint()}
        </React.Fragment>
      )
    } else {
      return nothingFound;
    }
  }

  return (
    <Container>
      {getItems()}
    </Container>
  )
}

CardGrid.propTypes = {
  data: PropTypes.array,
  small: PropTypes.bool,
  renderItem: PropTypes.func,
  nothingFound: PropTypes.element,
};

CardGrid.defaultProps = {
  xs: 12,
  sm: 6,
  md: 4,
  lg: 4,
  xl: 2,
  small: false,
  ancestor: null,
  nothingFound: <PlaceholderStyled title="No Results Found"/>,
};

export default CardGrid;
